import React from "react";
import TestCard from "../../pages/Dashboard/TestCard";
import Empty from "../../assets/assets/empty.svg";
import { useHistory } from "react-router-dom";
import Product from "../../pages/Dashboard/Product";
import { PropTypes } from "prop-types";

const Rejected = (props) => {
  const {
    status,
    hideBar,
    hideError,
    companyId,
    results,
    resultsLength,
    getStatus,
    categoryChoice,
    testCardStatus,
    userType,
    pos,
    application_info,
    goToSinglePage,
    expired
  } = props;
  const history = useHistory();

  const updatingStatus =
    status && status[0] && status[0].nibss_super_admin_status;
  const updatingStatus2 = status && status[0] && status[0].status;
  const rejectReason = status && status[0] && status[0].reject_reason;
  const posId = pos && pos[0] && pos[0].id;
  const id = pos && pos[0] && pos[0].id;
  const appType = status && status[0] && status[0].application_type;
  const certifiedStatus =
    updatingStatus === "pending" || updatingStatus2 === "pending";

  const update = (id, type) => {
    let payload = {
      id: id,
      status: updatingStatus2,
      nibss_super_admin_status: updatingStatus,
      company_id: companyId,
    };
    if (type === "pos_device_certification") {
      history.push({
        pathname: "/device/update",
        state: payload,
      });
    }
    if (type === "pos_application_certification") {
      history.push({
        pathname: "/application/update",
        state: payload,
      });
    }
  };

  return (
    <div>
      {hideError &&
        (updatingStatus2 === "rejected" || updatingStatus === "rejected") && (
          <div className="error-bar">
            <span>
              Your application for{" "}
              {appType === "pos_application_certification" ||
                appType === "pos_device_certification"
                ? "POS"
                : "products"}{" "}
              was rejected. <br /> Reason: {rejectReason}
            </span>
            <div
              data-testid="continue-sec"
              className="cancel-icon"
              onClick={() => hideBar()}
            >
              X
            </div>
          </div>
        )}
      <div className="dashboard-main-header">
        <div className="dashboard-main-header-title">
          <span>Products</span>
        </div>
      </div>

      {updatingStatus2 === "rejected" && (
        <div className="pos-doc-sec2">
          <div className="empty3">
            {application_info && application_info.length === 0 ? (
              <>
                <div>
                  <img src={Empty} alt="empty" />
                </div>
                <h1>No Products</h1>
                <p>
                  There are no products recieved. Please update your <br />
                  application.
                </p>
              </>
            ) : (
                <div className="documentation">
                  {application_info &&
                    application_info.map((doc) => (
                      <div className="overlay-holder" key={doc.id}>
                        <Product
                          docUrl={doc.url}
                          id={doc.id}
                          docName={doc.name}
                          goToSinglePage={goToSinglePage}
                          iconUrl={doc.image_url}
                          colorCode={doc.color_code}
                        />
                      </div>
                    ))}
                </div>
              )}
            <br />
            {appType === "pos_device_certification" && (
              <div>
                <div className="continue-sec">
                  <button
                    className="continue-sec-btn"
                    onClick={() => update(id, appType)}
                  >
                    update
                  </button>
                </div>
              </div>
            )}
            {appType === "pos_application_certification" && (
              <div>
                <div className="continue-sec">
                  <button
                    className="continue-sec-btn"
                    onClick={() => update(id, appType)}
                  >
                    update
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="testcard-main" style={{ marginTop: "0px" }}>
            <TestCard
              certifiedStatus={certifiedStatus}
              userType={userType}
              appId={posId}
              companyId={companyId}
              results={results}
              resultsLength={resultsLength}
              getUserStatus={getStatus}
              categoryChoice={categoryChoice}
              testCardStatus={testCardStatus}
            />
          </div>
        </div>
      )}

      {updatingStatus2 === "approved" && updatingStatus === "rejected" && (
        <div className="pos-doc-sec2">
          <div className="empty3">
            {application_info && application_info.length === 0 ? (
              <>
                <div>
                  <img src={Empty} alt="empty" />
                </div>
                <h1>No Products</h1>
                <p>
                  There are no products recieved. Please update your <br />
                  application.
                </p>
              </>
            ) : (
                <div className="documentation">
                  {application_info &&
                    application_info.map((doc) => (
                      <div className="overlay-holder" key={doc.id}>
                        <Product
                          docUrl={doc.url}
                          id={doc.id}
                          docName={doc.name}
                          goToSinglePage={goToSinglePage}
                          iconUrl={doc.image_url}
                          colorCode={doc.color_code}
                        />
                      </div>
                    ))}
                </div>
              )}
            <br />
            {appType === "pos_device_certification" && (
              <div>
                <div className="continue-sec">
                  <button
                    data-testid="cont-sec"
                    className="continue-sec-btn"
                    onClick={() => update(id, appType)}
                  >
                    update
                  </button>
                </div>
              </div>
            )}
            {appType === "pos_application_certification" && (
              <div>
                <div className="continue-sec">
                  <button
                    className="continue-sec-btn"
                    onClick={() => update(id, appType)}
                  >
                    update
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="testcard-main" style={{ marginTop: "0px" }}>
            <TestCard
              certifiedStatus={certifiedStatus}
              userType={userType}
              appId={posId}
              companyId={companyId}
              results={results}
              resultsLength={resultsLength}
              getUserStatus={getStatus}
              categoryChoice={categoryChoice}
              testCardStatus={testCardStatus}
              expired={expired}
            />
          </div>
        </div>
      )}
    </div>
  );
};

Rejected.propTypes = {
  hideBar: PropTypes.func,
  hideError: PropTypes.bool,
  status: PropTypes.array,
  application: PropTypes.object,
  companyId: PropTypes.number,
  results: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  resultsLength: PropTypes.array,
  getStatus: PropTypes.func,
  categoryChoice: PropTypes.number,
  testCardStatus: PropTypes.number,
  userType: PropTypes.string,
  pos: PropTypes.array,
  application_info: PropTypes.array,
  goToSinglePage: PropTypes.func
}

export default Rejected;
